HTMLFormElement.prototype.serializeObject = function() {
    const o = {};
    const formData = new FormData(this);
    formData.forEach((value, key) => {
        if (o[key] !== undefined) {
            if (!Array.isArray(o[key])) {
                o[key] = [o[key]];
            }
            o[key].push(value || '');
        } else {
            o[key] = value || '';
        }
    });
    return o;
};

function autoValidateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

function autoValidateDMY(param, value) {
    const [d, m, y] = value.split(param).map(Number);
    const res = new Date(y, m - 1, d);
    return !isNaN(res.getTime());
}

function autoValidateYMD(param, value) {
    const [y, m, d] = value.split(param).map(Number);
    const res = new Date(y, m - 1, d);
    return !isNaN(res.getTime());
}

function comprobarBloqueFormulario(cont_id) {
    const form = document.querySelector(`.form_${cont_id}`);
    // console.log(form)
    if (!form) return false;
    // if(!form) {console.log('aaaa')}
    let resultado = true;
	const labels = [];
    form.querySelectorAll(".has-error").forEach(el => el.classList.remove("has-error"));
    
    form.querySelectorAll("input.obli, textarea.obli").forEach(input => {
        if (input.offsetParent !== null && input.value.trim() === "") {
            resultado = false;
            input.closest(".form-floating").classList.add("has-error");
			input.parentElement.querySelectorAll('.invalid-feedback').forEach(fed => {
				fed.classList.add('d-none')
			})
			input.parentElement.querySelector('.invalid-feedback.empty').classList.remove('d-none')
			labels.push(input);
        }
    });
	form.querySelectorAll(".obliCheckOne").forEach(input => {
		if(!input.checked) {
            resultado = false;
			input.parentElement.classList.add("has-error");
			labels.push(input);
		}
    });
    form.querySelectorAll("select.obli").forEach(select => {
        if (select.offsetParent !== null && select.value.trim() === "") {
            resultado = false;
            select.closest(".form-floating").classList.add("has-error");
			select.parentElement.querySelectorAll('.invalid-feedback').forEach(fed => {
				fed.classList.add('d-none')
			})
			select.parentElement.querySelector('.invalid-feedback.empty').classList.remove('d-none')
			labels.push(select);
        }
    });

    form.querySelectorAll(".emailFormularioF").forEach(input => {
        if (input.offsetParent !== null && (input.classList.contains("obli") || input.value.trim() !== "")) {
            if (!autoValidateEmail(input.value)) {
                resultado = false;
                input.closest(".form-floating").classList.add("has-error");
				labels.push(input);
            }
        } 
		if (!autoValidateEmail(input.value) && input.value.trim() !== "") { 
			input.parentElement.querySelectorAll('.invalid-feedback').forEach(fed => {
				fed.classList.add('d-none')
			})
			input.parentElement.querySelector('.invalid-feedback.incorrect').classList.remove('d-none')
		}
		if ((input.classList.contains("obli") && input.value.trim() === "")) {
			input.parentElement.querySelectorAll('.invalid-feedback').forEach(fed => {
				fed.classList.add('d-none')
			})
			input.parentElement.querySelector('.invalid-feedback.empty').classList.remove('d-none')
		}
    });

    form.querySelectorAll(".fechaFormularioF").forEach(input => {
        if (input.offsetParent !== null) {
            const formato = input.getAttribute("dateformat");
            let valid = false;
            switch (formato) {
                case "dd-mm-yy": valid = autoValidateDMY("-", input.value); break;
                case "dd/mm/yy": valid = autoValidateDMY("/", input.value); break;
                case "yy/mm/dd": valid = autoValidateYMD("/", input.value); break;
                case "yy-mm-dd": valid = autoValidateYMD("-", input.value); break;
            }
            if (!valid) {
                resultado = false;
                input.closest(".form-floating").classList.add("has-error");
				labels.push(input);
            }
        }
    });
	if (labels.length > 0) {
        // const alert =;
        if(form.querySelector('.alertR')) {
            form.querySelector('.alertR').style.display = '';
        }
        if(form.parentElement.classList.contains('modal-body')) {
            form.parentElement.scrollTo({ top: form.querySelector('.alertR').offsetTop - 150, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: form.querySelector('.alertR').offsetTop - 150, behavior: 'smooth' });
        }
    }
    return resultado;
}

function sendBloqueFormulario(cont_id) {
    const form = document.querySelector(`.form_${cont_id}`);
    if (!form) return;
    
    const btnEnviar = form.querySelector(".btn-enviarForm");
    if(btnEnviar) {
        btnEnviar.disabled = true;
        btnEnviar.classList.add("loader-btn");
    }
    
    const formData = new FormData(form);
    formData.append("_csrf", document.querySelector('meta[name="csrf-token"]').getAttribute("content"));
    formData.append("lang_id", form.getAttribute("data-langid"));
    formData.append("cont_id", cont_id);
    formData.append("json", JSON.stringify(form.serializeObject()));
    formData.append("page", window.location.href);
    
    fetch(form.getAttribute("data-baseurl") + "/ajax/sendformulario", {
        method: "POST",
        body: formData
    }).then(response => response.json())
      .then(data => {
          if (data.sendform.code === 1) {
            //   form.classList.add("sended");
            if(form.classList.contains('send-hide') || form.parentElement.parentElement.classList.contains('send-hide') ) {
                form.classList.add('hide-inputs')
            }
              window.dispatchEvent(new CustomEvent('formularioEnviadoOk'));
              form.querySelector(".msgOK").style.display = "";
              form.reset();
              if( form.querySelector(".msgKO").style.display === "") {
                    form.querySelector(".msgKO").style.display = "none";
              }
              if( form.querySelector(".alertR").style.display === "") {
                    form.querySelector(".alertR").style.display = "none";
              }
            if(form.parentElement.classList.contains('modal-body')) {
                form.parentElement.scrollTo({ top: form.querySelector('.msgOK').offsetTop - 150, behavior: 'smooth' });
            } else {
                if(form.parentElement.parentElement.classList.contains('send-hide')) {
                    window.scrollTo({ top: form.parentElement.parentElement.offsetTop - 150, behavior: 'smooth' });
                } else {
                    window.scrollTo({ top: form.querySelector('.msgOK').offsetTop - 150, behavior: 'smooth' });
                }
            }
			//   window.scrollTo({ top: form.querySelector('.msgOK').offsetTop - 150, behavior: 'smooth' });
              form.querySelectorAll("input[type=checkbox]").forEach(chk => chk.checked = false);
              setTimeout(() => form.querySelector(".msgOK").style.display = "none", 6000);
                if(form.classList.contains('send-hide')) { 
                    setTimeout(() =>form.classList.remove('hide-inputs'), 6000);
                }
                if(form.parentElement.parentElement.classList.contains('send-hide')) { 
                    setTimeout(() =>form.classList.remove('hide-inputs'), 6000);
                }
          } else {
            if( form.querySelector(".msgOK").style.display === "") {
                form.querySelector(".msgOK").style.display = "none";
          }
              form.querySelector(".msgKO").style.display = "";
              form.querySelector(".alertR").style.display = "none";
            if(form.parentElement.classList.contains('modal-body')) {
                form.parentElement.scrollTo({ top: form.querySelector('.msgKO').offsetTop - 150, behavior: 'smooth' });
            } else {
                window.scrollTo({ top: form.querySelector('.msgKO').offsetTop - 150, behavior: 'smooth' });
            }
			//   window.scrollTo({ top: form.querySelector('.msgKO').offsetTop - 150, behavior: 'smooth' });
          }
      }).finally(() => {
		// window.scrollTo({ top: form.querySelector('.alertR').offsetTop - 150, behavior: 'smooth' });
          btnEnviar.disabled = false;
          btnEnviar.classList.remove("loader-btn");
      });
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".obli").forEach(input => {
        input.addEventListener("keyup", function() {
            let validated = false;
            switch (this.type) {
                case "email": 
					validated = autoValidateEmail(this.value); 
				break;
                case "phone": validated = this.value.length > 8; break;
                default: validated = this.value.length > 2; break;
            }
            gestionaClasesErrorValido(validated, this);
        });
    });

    document.querySelectorAll(".obliCheckOne").forEach(input => {

        input.addEventListener("click", function() {

            if (this.type === "checkbox") {
                gestionaClasesErrorValido(this.checked, this);
            }
        });
    });
    document.querySelectorAll(".form-select").forEach(input => {
        input.addEventListener("change", function() {
           gestionaClasesErrorValido(true, this);
        });
    });
});

function gestionaClasesErrorValido(valid, targetInput) {
    const grupo = targetInput.closest(".grupo");
    grupo.classList.remove("was-validated", "has-error");
    grupo.classList.add(valid ? "was-validated" : "has-error");
    
	if(grupo.querySelector('.emailFormularioF')) {
		if(grupo.querySelector('.emailFormularioF').value.length == 0) {
			grupo.querySelectorAll('.invalid-feedback').forEach(fed => {
				if(!fed.classList.contains('empty')) {
					fed.classList.add('d-none')
				} else {
					fed.classList.remove('d-none')
				}
			})
		} else {
			grupo.querySelectorAll('.invalid-feedback').forEach(fed => {
				if(!fed.classList.contains('incorrect')) {
					fed.classList.add('d-none')
				} else {
					fed.classList.remove('d-none')
				}
			})
		}
	} else {
        grupo.parentElement.querySelector('.invalid-feedback.empty').classList.remove('d-none')
    }
}
